import { get } from '~/shared/http-client/api'
import { type ApiResponse } from '~/shared/http-client/exceptions/type'

export type TicketInfo = {
  id: number
  admission_type: string
  created_at: string
  updated_at: string
  description: string
}

export type EventTicketInfo = {
  id: number
  event_id: number
  ticket_id: number
  admission_day: string
  option_1_amount: number
  amount: number
  discount_amount: number
  total_quantity: number
  current_quantity: number
  ongoing_quantity: number
  ticket_limit_quantity: number
  event_ticket_limit_quantity: number
  start_date: string
  end_date: string
  created_at: string
  updated_at: string
  availableTime: number
  remain_quantity: number
  user_ticket_count: number
  user_event_ticket_count: number
  max_user_buy: number
  description: string
}

export interface SpecialPerformanceDetailResponse extends ApiResponse {
  data: {
    ticket_info: TicketInfo
    event_ticket_info: EventTicketInfo
  }
}

// TODO 우선 하드코딩으로 21 넣어 놓음
// 추 후 특별 공연 페이지가 리스트로 나올 시 변수로 수정 필요
export const getSpecialPerformanceDetail = async (event_ticket_id: string) => {
  const response = await get<SpecialPerformanceDetailResponse>(
    `/shop/ticket/detail/${event_ticket_id}`,
  )

  return response.data
}
